import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../components/Table";
import axios from "axios";
import { apiKey } from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function PurchaseInventoryList({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [inventoryList, setInventoryList] = useState([]);
  const [newQty, setNewQty] = useState("");
  const [invToUpdate, setInvToUpdate] = useState({
    inventory_id: "",
    inventory_item: "",
    FullName: "",
    bank_account: "",
    balance: "",
    inventory_price: "",
    inventory_quantity: "",
    type: "",
    investor_id: "",
  });
  const [branchId, setBranchId] = useState();

  const handleQtyUpdate = (type) => {
    const qtyToAdd = parseFloat(newQty);
    if (!qtyToAdd || qtyToAdd <= 0) {
      toast.error("Please enter a valid quantity to add");
      return;
    }

    const calculatedPrice = invToUpdate.inventory_price * qtyToAdd;
    if (invToUpdate.balance < calculatedPrice) {
      toast.error("Insufficient Investor Balance");
      return;
    }

    if (type === "add") {
      axios
        .put(
          apiKey + "/add-item-quantity",
          {
            invId: invToUpdate.inventory_id,
            quantity: qtyToAdd,
            branch_id: branchId,
            investor_id: invToUpdate.investor_id,
            price: calculatedPrice,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          fetchInventory();
          toast.success(res.data.Message || "Inventory quantity added successfully", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          document.getElementById("closeModalBtn")?.click();
        })
        .catch((err) => {
          console.error(err);
          toast.error(err.response?.data?.Error || "Error occurred while adding quantity", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    } else {
      axios
        .put(
          apiKey + "/update-item-quantity",
          {
            invId: invToUpdate.inventory_id,
            quantity: qtyToAdd,
            branch_id: branchId,
            investor_id: invToUpdate.investor_id,
            price: calculatedPrice,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          fetchInventory();
          toast.success(res.data.Message || "Inventory quantity added successfully", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          document.getElementById("closeModalBtn")?.click();
        })
        .catch((err) => {
          console.error(err);
          toast.error(err.response?.data?.Error || "Error occurred while adding quantity", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  const getItemToUpdate = (inventoryId) => {
    axios
      .get(apiKey + "/get-item-to-update", {
        params: {
          branch_id: branchId,
          inventoryId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.result && res.data.result.length > 0) {
          setInvToUpdate(res.data.result[0]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchInventory = () => {
    try {
      axios
        .get(apiKey + "/get-items", {
          params: {
            branch_id: branchId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setInventoryList(res.data.result || []);
        });
    } catch (err) {
      console.error(err);
    }
  };

  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang["inventory"] || "Inventory",
      accessorKey: "inventory_item",
    },
    {
      header: lang.category || "Category",
      accessorKey: "type",
    },
    {
      header: lang.Investor || "Investor",
      accessorKey: "investor_name",
    },
    {
      header: lang.Purchase_Price || "Unit Purchase Price",
      accessorKey: "inventory_price",
      cell: (row) => Number(row.getValue() || 0).toFixed(2),
    },
    {
      header: lang.Quantity || "Current Quantity",
      accessorKey: "inventory_quantity",
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <button
                className="dropdown-item mt-0"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#myModal1"
                onClick={(e) => {
                  e.preventDefault();
                  getItemToUpdate(row.row.original.id);
                }}
              >
                {lang["Update Quantity"] || "Update Quantity"}
              </button>
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#myModal"
                onClick={(e) => {
                  e.preventDefault();
                  setNewQty("");
                  getItemToUpdate(row.row.original.id);
                }}
              >
                {lang.Add_Quantity || "Add Quantity"}
              </button>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (branchId) {
      fetchInventory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId]);

  useEffect(() => {
    setBranchId(
      JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id
    );
  }, []);

  return (
    <>
      <main id="main" className="main">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="pagetitle">
          <h1>
            {lang.Investment_Loan_Management || "Investment/Loan Management"}
          </h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item ">
                {lang.Investment_Loan_Management ||
                  "Investment/Loan Management"}
              </li>
              <li className="breadcrumb-item active">
                {lang.Inventory_List || "Inventory List"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row justify-content-end p-3">
                  <div className="col-md-5 col-lg-3">
                    <Link to="inventory-purchase">
                      <button type="button" className="btn btn-primary w-100">
                        <img
                          src="img/fi_plus.png"
                          alt=""
                          className="img-fluid me-2"
                        ></img>
                        {lang.Purchase_New_Item || "Purchase New Item"}
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="row px-3 pt-2">
                  <div className="rr col-9">
                    {lang.Inventory_List || "Inventory List"}
                  </div>
                </div>

                <div className="card-body">
                  <div className="d-flex mt-3 mb-3">
                    <Table
                      lang={lang}
                      data={inventoryList}
                      columns={columns}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="modal fade" id="myModal1" tabindex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleQtyUpdate("update");
                  }}
                >
                  <div className="row mb-2 mt-5 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Item || "Item"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={invToUpdate.inventory_item}
                          disabled
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Investor || "Investor"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={invToUpdate.FullName}
                          disabled
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Account || "Account"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={invToUpdate.bank_account}
                          disabled
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Balance || "Balance"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={invToUpdate.balance}
                          disabled
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Price || "Price"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          disabled
                          value={invToUpdate.inventory_price}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-2 d-flex justify-content-center">
                    <div className="col-sm-8  mb-3">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Quantity || "Quantity"}
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={newQty}
                          onChange={(e) => setNewQty(e.target.value)}
                          required
                        />
                      </label>
                    </div>
                  </div>
                  <div className="text-center mb-5">
                    <button
                      id="closeModalBtn"
                      type="button"
                      className="btn-save"
                      data-bs-dismiss="modal"
                    >
                      {lang.Cancel || "Cancel"}
                    </button>
                    <button type="submit" className="btn-cancel ms-5">
                      {lang.Add_Now || "Add Now"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Modal for Adding Inventory Quantity */}
        <div className="modal fade" id="myModal" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4 p-2">
              <div className="modal-body pt-4 pb-3">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleQtyUpdate("add");
                  }}
                >
                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-sm-9">
                      <label className="w-100 mb-1 text-secondary" style={{ fontSize: "14px", fontWeight: "500" }}>
                        {lang.Item || "Item"}
                      </label>
                      <input
                        type="text"
                        className="form-control border-0 bg-light rounded-3 py-2 px-3 text-dark"
                        style={{ backgroundColor: "#f8f9fa" }}
                        value={invToUpdate.inventory_item || ""}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-sm-9">
                      <label className="w-100 mb-1 text-secondary" style={{ fontSize: "14px", fontWeight: "500" }}>
                        {lang.Investor || "Investor"}
                      </label>
                      <input
                        type="text"
                        className="form-control border-0 bg-light rounded-3 py-2 px-3 text-dark"
                        style={{ backgroundColor: "#f8f9fa" }}
                        value={invToUpdate.FullName || ""}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-sm-9">
                      <label className="w-100 mb-1 text-secondary" style={{ fontSize: "14px", fontWeight: "500" }}>
                        {lang.Account || "Account"}
                      </label>
                      <input
                        type="text"
                        className="form-control border-0 bg-light rounded-3 py-2 px-3 text-dark"
                        style={{ backgroundColor: "#f8f9fa" }}
                        value={invToUpdate.bank_account || ""}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-sm-9">
                      <label className="w-100 mb-1 text-secondary" style={{ fontSize: "14px", fontWeight: "500" }}>
                        {lang.Balance || "Balance"}
                      </label>
                      <input
                        type="text"
                        className="form-control border-0 bg-light rounded-3 py-2 px-3 text-dark"
                        style={{ backgroundColor: "#f8f9fa" }}
                        value={invToUpdate.balance !== undefined && invToUpdate.balance !== null ? invToUpdate.balance : ""}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-sm-9">
                      <label className="w-100 mb-1 text-secondary" style={{ fontSize: "14px", fontWeight: "500" }}>
                        {lang.Price || "Price"}
                      </label>
                      <input
                        type="text"
                        className="form-control border-0 bg-light rounded-3 py-2 px-3 text-dark"
                        style={{ backgroundColor: "#f8f9fa" }}
                        value={invToUpdate.inventory_price !== undefined && invToUpdate.inventory_price !== null ? invToUpdate.inventory_price : ""}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="row mb-4 d-flex justify-content-center">
                    <div className="col-sm-9">
                      <label className="w-100 mb-1 text-secondary" style={{ fontSize: "14px", fontWeight: "500" }}>
                        {lang.Quantity || "Quantity"}
                      </label>
                      <input
                        type="text"
                        className="form-control border-0 bg-light rounded-3 py-2 px-3"
                        style={{ backgroundColor: "#f8f9fa" }}
                        value={newQty}
                        onChange={(e) => setNewQty(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-center gap-3 mt-4 mb-3">
                    <button
                      id="closeModalBtn"
                      type="button"
                      className="btn px-4 py-2 rounded-3 fw-medium text-white"
                      data-bs-dismiss="modal"
                      style={{ backgroundColor: "#0066ff", borderColor: "#0066ff", minWidth: "110px" }}
                    >
                      {lang.Cancel || "Cancel"}
                    </button>
                    <button
                      type="submit"
                      className="btn px-4 py-2 rounded-3 fw-medium"
                      style={{ backgroundColor: "#dbeafe", color: "#2563eb", border: "none", minWidth: "110px" }}
                    >
                      {lang.Add_Now || "Add Now"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
